import Vue from 'vue'
import Vuex from 'vuex'
import {
  NS_GAME_STATE,
  NS_TURN_STATE,
  NS_LAYER_STATE,
} from "./constants";
import GameStateModule from './game';
import TurnStateModule from './turn';
import LayerStateModule from './layer';
import LogRocket from 'logrocket';
import createPlugin from 'logrocket-vuex';

const logrocketPlugin = createPlugin(LogRocket);

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    [NS_GAME_STATE]: GameStateModule,
    [NS_TURN_STATE]: TurnStateModule,
    [NS_LAYER_STATE]: LayerStateModule,
  },
  plugins: [logrocketPlugin],
});
